export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11351.74b4cdb7.jpg";